import { ChevronRight } from '@mui/icons-material';
import { OverflowTooltip } from 'components/ui';
import { Footer, FooterContext, FooterContextName, KeyCap, KeyHint } from './SuperSearch.styles';
import type { SuperSearchContext, SuperSearchShortcut } from './SuperSearch.types';

interface SuperSearchFooterProps {
  context: SuperSearchContext;
  pressedShortcut?: SuperSearchShortcut;
}

const SuperSearchFooter = ({ context, pressedShortcut }: SuperSearchFooterProps) => (
  <Footer aria-label="Super Search keyboard shortcuts" role="note">
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'navigate' || undefined}>↑↓</KeyCap> navigate
    </KeyHint>
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'go' || undefined}>↵</KeyCap> go
    </KeyHint>
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'setScope' || undefined}>tab</KeyCap> set scope
    </KeyHint>
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'popScope' || undefined}>⌫</KeyCap> pop scope
    </KeyHint>
    <KeyHint>
      <KeyCap data-pressed={pressedShortcut === 'close' || undefined}>esc</KeyCap> close
    </KeyHint>
    {(context.firm || context.company) && (
      <FooterContext>
        {context.firm && (
          <OverflowTooltip placement="top" title={context.firm.name}>
            <FooterContextName tone="firm">{context.firm.name}</FooterContextName>
          </OverflowTooltip>
        )}
        {context.company && (
          <>
            <ChevronRight />
            <OverflowTooltip placement="top" title={context.company.name}>
              <FooterContextName tone="company">{context.company.name}</FooterContextName>
            </OverflowTooltip>
          </>
        )}
      </FooterContext>
    )}
  </Footer>
);

export default SuperSearchFooter;
